// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  setLogLevel,
} from "firebase/firestore";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDiyYiuBlpkNNlMmQYAjsoGHBceiEzLxlU", // ← CORRECTA (con L)
 authDomain: "valenshop-pos.firebaseapp.com",
  projectId: "valenshop-pos",
  storageBucket: "valenshop-pos.appspot.com",
  messagingSenderId: "101518259156",
  appId: "1:101518259156:web:7d444f341ea1cf898c9c41",
};

export const app = initializeApp(firebaseConfig);

// Firestore
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});

// Auth
export const auth = getAuth(app);
export const authPersistenceReady = setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.warn('No se pudo configurar la persistencia local de la sesion', error);
});

// Logging Firestore en debug para medir lecturas en desarrollo
